// extracted by mini-css-extract-plugin
export var emailBlockLink = "_gz-0";